export function contentToText(value) {
  if (value == null) return "";
  if (typeof value === "string") return value;
  if (!Array.isArray(value)) {
    if (typeof value === "object") {
      const raw = value.message ?? value.content ?? value.text ?? "";
      return typeof raw === "string" ? raw : contentToText(raw);
    }
    return "";
  }

  const textItems = value.filter((item) => item?.type === "text" && item?.text);
  if (textItems.length > 0) {
    return textItems.map((item) => item.text).join("\n\n");
  }
  const fallback = value.find((item) => item?.text || item?.content || item?.message);
  return fallback?.text || fallback?.content || fallback?.message || "";
}

const DEFAULT_DOCUMENT_TITLE = "Document";

/**
 * Extracts a document title from message content (same logic as old canvas).
 * Uses markdown heading, then first line (5-50 chars), then default.
 */
export function extractDocumentTitle(content) {
  const text = typeof content === "string" ? content : contentToText(content);
  if (!text || !text.trim()) return DEFAULT_DOCUMENT_TITLE;

  const headingMatch = text.match(/^\s*#{1,3}\s+([^\n]+)/);
  if (headingMatch) return headingMatch[1].trim();

  const firstLineMatch = text.match(/^([^\n]{5,50})\n/);
  if (firstLineMatch) return firstLineMatch[1].trim();

  return DEFAULT_DOCUMENT_TITLE;
}

export function isDocumentLikeContent(content) {
  if (content == null) return false;

  const text = typeof content === "string" ? content : contentToText(content);
  return typeof text === "string" && text.length > 200;
}

/**
 * Short description for document cards: first line/paragraph, capped at maxLength.
 */
export function extractDocumentDescription(content, maxLength = 120) {
  const text = typeof content === "string" ? content : contentToText(content);
  if (!text || !text.trim()) return "";

  const normalized = text
    .replace(/^\s*#{1,6}\s+/gm, "")
    .replace(/\n+/g, " ")
    .trim();
  if (!normalized) return "";

  if (normalized.length <= maxLength) return normalized;
  return normalized.slice(0, maxLength).trim() + "…";
}
